// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// static
import CheckedOriginIcon from '@mui/icons-material/Check'
// utils
import { size } from 'polished'

const CheckedIcon = styled(CheckedOriginIcon)`
  margin-right: 10px;
  ${size('14px')};
  right: 0;
`

const Label = styled('label')`
  align-items: center;
  color: ${colors.blue500};
  cursor: pointer;
  display: flex;
  font-weight: 500;
  height: 40px;
  justify-content: space-between;
  padding: 0 10px;

  &:hover {
    background-color: ${colors.gray190};
  }

  > input {
    display: none;
  }
`

export { Label, CheckedIcon }
